import { ADD_GROUP_ROLL, DESTROY_GROUP_ROLL, UPDATE_GROUP_ROLL } from "../constants/action-types"
import { jankyRainbow } from '../lib/pixellib'
import store from '../store'

const initialState = {
  list: INITIAL.groupRolls
}

export default (state = initialState, action) => {
  let groupRollId
  let groupRollData

  if (action.payload) {
    groupRollId = action.payload.id
    groupRollData = action.payload
  }

  switch(action.type) {
    case ADD_GROUP_ROLL:
      // Trigger pixel animation after state update
      setTimeout(() => {
        const pixels = Object.values(store.getState().pixels.list);
        for (const pixel of pixels) {
          if (pixel.pixel && typeof pixel.pixel.blink === 'function') {
            try {
              jankyRainbow(pixel.pixel);
            } catch (e) {
              console.error('[Pixel Debug] Pixel blink error (red):', e);
            }
          }
        }
      }, 0);

      return {
        ...state,
        list: {
          ...state.list,
          [groupRollId]: groupRollData
        }
      }
    case UPDATE_GROUP_ROLL:
      return {
        ...state,
        list: {
          ...state.list,
          [groupRollId]: groupRollData
        }
      }
    case DESTROY_GROUP_ROLL:
      const { [action.payload.id]: _, ...withoutGroupRoll } = state.list;
      return {
        ...state,
        list: withoutGroupRoll,
      }
    default:
      return state
  }
}
